module.exports = __webpack_public_path__ + "img/ej-05.84cc8e95.svg";